<template>
    <div class="liangtang">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>量堂</span><span>智能量化回测平台</span>
                    </p>
                    <p>
                        量堂智能量化回测平台是基于人工智能、大数据的在线实时量化回测平台。海量的金融大数据处理、高性能的风险回测模型、丰富的量化策略工具与可视化归因分析，为用户打造专业量化投资与智能投顾服务于一体的量化回测平台，提供全方位一体化的用户解决方案。
                    </p>
                </div>

            </div>
        </div>

        <div class="two">
            <div class="content">
                <div class="two-title">
                    <p>量化策略流程图</p>
                </div>
                <img src="../assets/liangtang-back-one.png"
     srcset="../assets/liangtang-back-one@2x.png 2x,
             ../assets/liangtang-back-one@3x.png 3x"
     class="liangtang-back-one">
                
            </div>
        </div>
        <div class="three">
            <div class="content">
                <img src="../assets/liangtang-back-two.png"
     srcset="../assets/liangtang-back-two@2x.png 2x,
             ../assets/liangtang-back-two@3x.png 3x"
     class="liangtang-back-two">
                <div class="text">
                    <p>
                        回测结果中包含买、卖信号，持仓收益、Alpha、Beta等形式丰富的结果展示，助力开发者更直观的观察回测策略的可靠性，以便及时作出量化策略的调整。
                    </p>
                    <p>
                        Jupyter  Notebook是进项量化研究、策略开发、文档编写的集成开发环境，是有独立空间的Python环境。平台支持统计分析、数据可视化、数据预处理、机器学习。此外，在Notebook集成了平台自研的API，方便用户熟悉平台API，提高编写效率。
                    </p>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'liangtang'
}
</script>

<style lang="scss">
.liangtang{
    min-width: 1000px;
    .first{
        min-height: 380px;
        background: url("../assets/liangtang-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/liangtang-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/liangtang-back-first@3x.jpg") no-repeat center/cover;
        }

        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            .text{
                width: 637px;
                margin: 0 auto;
                margin-top: 126px;
                text-align: center;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-bottom: 24px;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
        }
    }
   .two{
        .content{
           width: 1000px;
           margin: 75px auto;
           text-align: center;
           .two-title{
               margin-bottom: 44px;
               p:nth-child(1){
                   font-size: 30px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    color: #000;
               }
           }
        
        }
    }
    .three{
        .content{
            width: 1000px;
            margin: 75px auto;
            display: flex;
            img{
                margin-left: -200px;
            }
            .text{
                margin-left:54px;
                p{
                    font-size: 14px;
                    width: 278px;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.86;
                    letter-spacing: normal;
                    color: #000; 
                }
                p:nth-child(1){
                    margin-top:140px;
                    margin-bottom: 27px;
                }
            }
        }
    }
}
</style>